// extracted by mini-css-extract-plugin
export default {"table-container":"JffxK99Xl8WT5Zstgb5O","table-wrapper":"LQkHIH78yL7BXeUNEAJ9"};